import DateBox from "devextreme-react/date-box";
import NumberBox from "devextreme-react/number-box";
import SwitchBox from 'devextreme-react/switch';
import TextBox from "devextreme-react/text-box";
import React, { useCallback, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { Modal } from 'semantic-ui-react';
import { phuHuynhApi } from '../../../../api/phuHuynhApi';
import { quanHeGiaDinhApi } from '../../../../api/quanHeGiaDinhApi';
import { DefaultButton, PrimaryButton } from '../../../../components/editor/button';
import ComboboxQuanHe from '../../../../components/editor/cmb_quanhe';
import ComboboxQuocTich from '../../../../components/editor/cmb_quoctich';
import { InValidMessage } from '../../../../components/editor/invalid_message';
import { FormGroup } from '../../../../components/form-group';
import { useCommonContext } from '../../../../contexts/common';
import { showNotify } from '../../../../helpers/toast';
import styles from '../QuanHeGiaDinhHocSinh.module.css';


const QuanHeGiaDinhEditModal = ({ ts_hocsinh_id, id, onCancel, onSuccess }) => {
	const [formData, setformData] = useState({ id: id || 0 });
	const [isSaving, setisSaving] = useState(false);
	const { register, trigger, errors } = useForm();
	const { translate } = useCommonContext();
	const { dm_coso_id } = useSelector((x) => x.coSo);

	const handleGetDetail = useCallback(async () => {
		if (ts_hocsinh_id > 0) {
			const res = await phuHuynhApi.SelectByHocSinhQuanHeGiaDinh(ts_hocsinh_id, id);
			if (res.is_success) {
				const data = res.data;
				if (data) {
					setformData((formData) => ({
						...formData,
						ts_phuhuynh_id: data.id,
						ho_ten: data.ho_ten,
						dien_thoai: data.dien_thoai,
						email: data.email,
						dm_gioitinh_id: data.dm_gioitinh_id,
						dm_quanhe_id: data.dm_quanhe_id,
						dia_chi_thuong_tru: data.dia_chi_thuong_tru,
						chung_minh_thu: data.chung_minh_thu,
						ngay_cap_chung_minh_thu: data.ngay_cap_chung_minh_thu,
						noi_cap_chung_minh_thu: data.noi_cap_chung_minh_thu,
						ngay_sinh: data.ngay_sinh,
						dm_quoctich_id: data.dm_quoctich_id,
						nghe_nghiep: data.nghe_nghiep,
						noi_lam_viec: data.noi_lam_viec,
						is_uutien: data.is_uutien,
						id: id,
					}));
				}
			}
		}
	}, [ts_hocsinh_id]);
	useEffect(() => {
		handleGetDetail();
	}, [ts_hocsinh_id]);
	const handleSaveChanges = async () => {
		const formDataSubmit = {
			...formData,
			ts_hocsinh_id: ts_hocsinh_id,
			dm_coso_id: dm_coso_id,
		};
		trigger().then(async (isValid) => {
			if (isValid) {
				// if (!formData.dien_thoai.toString().startsWith('0')) {
				// 	showNotify({ text: 'Số điện thoại phải bắt đầu từ số 0', type: 'error' });
				// 	return;
				// }
				// if (formData.dien_thoai.toString().length != 10) {
				// 	showNotify({ text: 'Số điện thoại chỉ bao gồm 10 số', type: 'error' });
				// 	return;
				// }
				let res;
				setisSaving(true);
				if (formDataSubmit.id > 0) {
					res = await quanHeGiaDinhApi.Update(formDataSubmit);
				} else {
					res = await quanHeGiaDinhApi.Insert(formDataSubmit);
				}
				setisSaving(false);
				if (res.is_success) {
					showNotify({ type: 'success', text: translate('Cập nhật thành công') });
					onSuccess();
				} else {
					showNotify({ type: 'error', text: translate('Có lỗi xảy ra') });
				}
			}
		});
	};
	return (
		<>
			<Modal
				open={true}
				className={styles.modal_center}
				size='small'
				dimmer={'blurring'}
				onClose={onCancel}
				closeOnEscape={false}
				closeOnDimmerClick={false}
			>
				<Modal.Header>{formData.id > 0 ? <p>{translate('Cập nhật')}</p> : <p>{translate('Thêm mới')}</p>}</Modal.Header>
				<Modal.Content>
					<form className='ui'>
						<div className='row'>
						<div className='col-md-6'>
								<FormGroup label={translate('Quan hệ')}>
									<ComboboxQuanHe
										value={formData.dm_quanhe_id}
										isDontShowAce={true}
										width='100%'
										onValueChanged={(value) => {
											setformData({ ...formData, dm_quanhe_id: value});
											trigger('dm_quanhe_id');
										}}
									/>
									<InValidMessage
										defaultValue={formData.dm_quanhe_id}
										errors={errors}
										message={translate('Vui lòng chọn quan hệ với học sinh')}
										name={'dm_quanhe_id'}
										register={register({ required: true, min: 1 })}
									/>
								</FormGroup>
							</div>
							<div className='col-md-6'>
								<FormGroup label={translate('Họ tên')}>
									<TextBox
										stylingMode='outlined'
										value={formData.ho_ten}
										valueChangeEvent='keyup'
										onValueChanged={(e) => {
											if (e.event) {
												setformData({ ...formData, ho_ten: e.value });
												trigger('ho_ten');
											}
										}}
									/>
									<InValidMessage
										defaultValue={formData.ho_ten}
										errors={errors}
										message={translate('Vui lòng điền họ tên')}
										name={'ho_ten'}
										register={register({ required: true })}
									/>
								</FormGroup>
							</div>
							{/* <div className='col-md-6'>
                                <FormGroup label={"Ngày sinh"}>
                                    <DateBox
                                        stylingMode='outlined'
                                        type='date'
                                        displayFormat={'dd-MM-yyyy'}
                                        value={formData.ngay_sinh || new Date()}
                                        onValueChanged={(e) => {
                                            if (e.event) {
                                                setformData({ ...formData, ngay_sinh: e.value });
                                                trigger("ngay_sinh")
                                            }
                                        }}
                                    />
                                </FormGroup>
                            </div> */}
						</div>
						<div className='row'>
							<div className='col-md-6'>
								<FormGroup label={translate('Email')}>
									<TextBox
										stylingMode='outlined'
										value={formData.email}
										valueChangeEvent='keyup'
										onValueChanged={(e) => {
											if (e.event) {
												setformData({ ...formData, email: e.value });
												trigger('email');
											}
										}}
									/>
									<InValidMessage
										defaultValue={formData.email}
										errors={errors}
										message={translate('Vui lòng nhập email')}
										name={'email'}
										register={register({ required: true })}

									/>
								</FormGroup>
							</div>
							<div className='col-md-6'>
								<FormGroup label={translate('Điện thoại')}>
									<TextBox
										stylingMode='outlined'
										value={formData.dien_thoai}
										valueChangeEvent='keyup'
										onValueChanged={(e) => {
											if (e.event) {
												setformData({ ...formData, dien_thoai: e.value });
												trigger('dien_thoai');
											}
										}}
									/>
									<InValidMessage
										defaultValue={formData.dien_thoai}
										errors={errors}
										message={translate('Vui lòng điền số điện thoại')}
										name={'dien_thoai'}
										register={register({ required: true, min: 0 })}
									/>
								</FormGroup>
							</div>
						</div>
						<div className='row'>
							<div className='col-md-6'>
								<FormGroup label={translate('Quốc tịch')}>
									<ComboboxQuocTich
										value={formData.dm_quoctich_id == 0 || formData.dm_quoctich_id == null ? formData.dm_quoctich_id = 1 : formData.dm_quoctich_id}
										width='100%'
										onValueChanged={(value) => {
											setformData({ ...formData, dm_quoctich_id: value });
											trigger('dm_quoctich_id');
										}}
									/>
								</FormGroup>
							</div>
							<div className='col-md-6'>
								<FormGroup label={translate('CMND/CCCD')}>
									<TextBox
										stylingMode='outlined'
										onValueChanged={(e) => {
											if (e.event) {
												setformData({ ...formData, chung_minh_thu: e.value });
												trigger('chung_minh_thu');
											}
										}}
										value={formData.chung_minh_thu}
									/>
								</FormGroup>
							</div>
						</div>
						<div className='row'>
							<div className='col-md-6'>
								<FormGroup label={translate('Ngày cấp CMND/CCCD')}>
									<DateBox
										stylingMode='outlined'
										type='date'
										displayFormat={'dd-MM-yyyy'}
										value={formData.ngay_cap_chung_minh_thu}
										onValueChanged={(e) => {
											if (e.event) {
												setformData({ ...formData, ngay_cap_chung_minh_thu: e.value });
												trigger('ngay_cap_chung_minh_thu');
											}
										}}
									/>
								</FormGroup>
							</div>
							<div className='col-md-6'>
								<FormGroup label={translate('Nơi cấp CMND/CCCD')}>
									<TextBox
										stylingMode='outlined'
										value={formData.noi_cap_chung_minh_thu}
										onValueChanged={(e) => {
											if (e.event) {
												setformData({ ...formData, noi_cap_chung_minh_thu: e.value });
												trigger('noi_cap_chung_minh_thu');
											}
										}}
									/>
								</FormGroup>
							</div>
						</div>

						<div className='row'>
							<div className='col-md-6'>
								<FormGroup label={translate('Địa chỉ thường trú')}>
									<TextBox
										value={formData.dia_chi_thuong_tru}
										width='100%'
										stylingMode='outlined'
										onValueChanged={(e) => {
											if (e.event) {
												setformData({ ...formData, dia_chi_thuong_tru: e.value });
												trigger('dia_chi_thuong_tru');
											}
										}}
									/>
								</FormGroup>
							</div>
							<div className='col-md-6'>
								<FormGroup label={translate('Nghề nghiệp')}>
									<TextBox
										stylingMode='outlined'
										value={formData.nghe_nghiep}
										onValueChanged={(e) => {
											if (e.event) {
												setformData({ ...formData, nghe_nghiep: e.value });
												trigger('nghe_nghiep');
											}
										}}
									/>
								</FormGroup>
							</div>
						</div>
						<div className='row'>
							<div className='col-md-6'>
								<FormGroup label={translate('Nơi làm việc')}>
									<TextBox
										stylingMode='outlined'
										value={formData.noi_lam_viec}
										onValueChanged={(e) => {
											if (e.event) {
												setformData({ ...formData, noi_lam_viec: e.value });
												trigger('noi_lam_viec');
											}
										}}
									/>
								</FormGroup>
							</div>
							<div className='col-md-6'>
								<FormGroup label={translate('Liên hệ chính')}>
									<SwitchBox
										value={formData.is_uutien}
										onValueChanged={(e) => {
											if (e.event) {
												setformData({ ...formData, is_uutien: e.value });
												trigger('is_uutien');
											}
										}}
									/>
								</FormGroup>
							</div>
						</div>
					</form>
				</Modal.Content>
				<Modal.Actions>
					<div>
						<DefaultButton text={translate('Đóng')} onClick={onCancel} />
						<PrimaryButton text={id > 0 ? translate('Cập nhật') : translate('Thêm mới')} onClick={handleSaveChanges} isLoading={isSaving} />
					</div>
				</Modal.Actions>
			</Modal>
		</>
	);
};

export default QuanHeGiaDinhEditModal;
